import React, { createContext, useContext, useState, useEffect } from 'react';
import { useToast } from '@/components/ui/use-toast';

const FavoritesContext = createContext();

export const useFavorites = () => {
    return useContext(FavoritesContext);
};

export const FavoritesProvider = ({ children }) => {
    const [favorites, setFavorites] = useState([]);
    const { toast } = useToast();

    useEffect(() => {
        const storedFavorites = localStorage.getItem('futura_favorites');
        if (storedFavorites) {
            setFavorites(JSON.parse(storedFavorites));
        }
    }, []);

    const addFavorite = (property) => {
        setFavorites((prev) => {
            if (prev.some((p) => p.id === property.id)) return prev;
            const newFavorites = [...prev, property];
            localStorage.setItem('futura_favorites', JSON.stringify(newFavorites));
            toast({
                title: "Propiedad guardada",
                description: `${property.title} se ha añadido a tus favoritos.`,
            });
            return newFavorites;
        });
    };

    const removeFavorite = (propertyId) => {
        setFavorites((prev) => {
            const newFavorites = prev.filter((p) => p.id !== propertyId);
            localStorage.setItem('futura_favorites', JSON.stringify(newFavorites));
            toast({
                title: "Propiedad eliminada",
                description: "Se ha eliminado de tus favoritos.",
                variant: "destructive"
            });
            return newFavorites;
        });
    };

    const isFavorite = (propertyId) => {
        return favorites.some((p) => p.id === propertyId);
    };

    const toggleFavorite = (property) => {
        if (isFavorite(property.id)) {
            removeFavorite(property.id);
        } else {
            addFavorite(property);
        }
    };

    return (
        <FavoritesContext.Provider value={{ favorites, addFavorite, removeFavorite, isFavorite, toggleFavorite }}>
            {children}
        </FavoritesContext.Provider>
    );
};
